import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { currentUser, loading } = useAuth();
    const { userID } = useParams();

    // Show loading while auth state is being determined
    if (loading) {
        return (
            <div className="loading-container">
                <div className="custom-spinner">
                    <div className="spinner-circle"></div>
                    <div className="spinner-circle"></div>
                    <div className="spinner-circle"></div>
                </div>
                <h2 className="mt-3" dir="rtl">
                    טוען נתונים...
                </h2>
            </div>
        );
    }

    // If no user is authenticated, redirect to auth page
    if (!currentUser) {
        return <Navigate to="/manager/auth" replace />;
    }

    // If userID in URL doesn't match current user's UID, redirect to correct dashboard
    if (userID && currentUser.uid !== userID) {
        return <Navigate to={`/manager/auth/dashboard/${currentUser.uid}`} replace />;
    }

    // If no userID in URL but user is authenticated, redirect to their dashboard
    if (!userID && currentUser) {
        return <Navigate to={`/manager/auth/dashboard/${currentUser.uid}`} replace />;
    }

    // User is authenticated and URL matches, render the protected content
    return children;
};

export default ProtectedRoute; 